import React from "react";
import styled from "styled-components";
import {Col, Nav, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

const FooterContainer = styled.div<{ $sticky: boolean }>`
  padding: 1rem 0;
  ${props => props.$sticky && `
    position: fixed;
    bottom: 0;
    width: 100%;
    backdrop-filter: blur(10px);
  `}
`;

export const Footer = ({ sticky = false }: { sticky?: boolean }) => (
    <FooterContainer $sticky={sticky}>
        <Row className="mt-4">
            <Col md={4} className="mt-2">
                <Nav.Link as={Link} to="/terms/">
                    <p>Terms of Use</p>
                </Nav.Link>
            </Col>
            <Col md={4} className="mt-2">
                <Nav.Link as={Link} to="/privacy/">
                    <p>Privacy Policy</p>
                </Nav.Link>
            </Col>
  {/*           <Col md={3} className="mt-2">
                <Nav.Link as={Link} to="/faqs">
                    <p>FAQ's</p>
                </Nav.Link>
            </Col> */}
            <Col md={4} className="mt-2">
                <Nav.Link as={Link} to="/contact">
                    <p>Support</p>
                </Nav.Link>
            </Col>
        </Row>
    </FooterContainer>
);
